/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { DataContainer, DataItem } from "~/components";
import { useCurrency } from "~/hooks";
import { formatMoney } from "~/tools";

type Props = {
  currentMonthTotal?: string | null;
  count?: number | null;
  recordsType?: string;
};

export function EstateData({ count, currentMonthTotal, recordsType }: Props) {
  const { currency } = useCurrency();

  const textWeight = recordsType ? "regular" : undefined;

  return (
    <DataContainer>
      <DataItem
        label={`Total ${recordsType ?? "Estate Records"}`}
        value={count?.toString() ?? ""}
        size="lg"
        grow={false}
        weight={textWeight}
      />
      <DataItem
        label="Monthly Cost"
        value={formatMoney(currentMonthTotal, currency)}
        size="lg"
        grow={false}
        weight={textWeight}
      />
    </DataContainer>
  );
}
